export const config = {
    baseUrl: import.meta.env.BASE_URL,
} as const
